export enum LicenceTypes {
  SIMULTANEOUS_AUTH = 'Usuários simultâneos',
  AVAILABLE_USERS = 'Usuários nominados'
}
